import CommonIcon from './common-icon.vue'
export default CommonIcon



// WEBPACK FOOTER //
// ./src/components/common-icon/index.js